import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchBrandSales = fetchGeneralData<SalesPayload>(
    `${ApiSubUrls[Apis.BRANDS]}/brand_sales/`,
)
export const fetchBrandsGreenFields = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export const fetchBrandsLoyalty = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/greenfield/cards/`,
)

export type SalesBreakdown = {
    originated: number
    ship_from_store: number
    order_pickup: number
}

export type SalesBreakdownPercentage = {
    originated: number
    ship_from_store: number
    order_pickup: number
}

export type Sales = {
    sales: number
    sales_percentage: number | string
    sales_breakdown: SalesBreakdown
    sales_breakdown_percentage: SalesBreakdownPercentage
}

export type LocationSalesData = {
    location_description: string
    sales: number
    originated: number
    fulfilled: number
}

export type SalesByLocationDayEntry = {
    parent_locations: LocationSalesData[]
    children_locations: LocationSalesData[]
    current_location: LocationSalesData | null
}

export type SalesByLocation = {
    day: SalesByLocationDayEntry[]
}

export type ItemOrClassEntry = {
    name: string
    sales: number
    sales_quantity: number
    rank: number
    type: 'Top' | 'Bottom'
}

export type BrandClass = {
    subClassToday: ItemOrClassEntry[]
}

export type BrandItem = {
    subItemToday: ItemOrClassEntry[] // Same structure as BrandClassEntry
}

export const SalesKeyValues = ['day', 'yesterday', 'week', 'month', 'year']

export type SalesKeys = (typeof SalesKeyValues)[number]

export type SalesRecord = {
    id: string
    date: string // Consider using `Date` if you plan to parse it
    brand_id: string
    location_id: string
    is_empty: boolean
    sales_by_location: SalesByLocation
    brand_class?: BrandClass
    brand_item?: BrandItem
} & {
    [key in SalesKeys]: Sales
}

export type SalesPayload = SalesRecord[]
